import { createTheme } from "@mui/material/styles"

const theme = createTheme({
  navHeight: 76,
  sectionPadding: "padding-top: 1.5em; padding-bottom: 1.5em;",
  fonts: {
    primary: "Montserrat, sans-serif",
    secondary: "Playfair Display, serif",
  },
  layout: {
    contentWidth: 1236,
  },
  palette: {
    primary: {
      main: "#A8937A",
      light: "#D9C3AA",
      dark: "#18191A",
    },
    secondary: {
      main: "#C0BFBF",
      light: "#F9F9F9",
      dark: "#16233C",
    },
    tertiary: {
      main: "#F1F1F1",
      light: "#FCFCFC",
      dark: "#18191A",
    },
    text: {
      primary: "#1D1D1F",
      secondary: "#18191A",
      content: "#000000",
      tertiary: "#FCFCFC",
      disabled: "#737374",
      hint: "#737374",
      light: "#FFFFFF",
      error: "#d32f2f",
    },
    alternate: {
      main: "#D9C3AA",
      dark: "#F1F1F1",
    },
  },
  typography: {
    fontFamily: `"Montserrat", "Playfair Display", "Open Sans", "Arial", sans-serif`,
  },
})

export default theme
